class ProductBoxSubscriptionCreatine extends HTMLElement {
  constructor() {
    super();

    this.SELECTORS = {
      productFlavor: '.js-flavor-item',
      flavorSelectorDescription: '.js-flavor-selector-description',
      addToCartBtn: '.js-add-to-cart-btn',
      productBoxOption: '.js-product-box-option',
      samplerOption: '.js-sampler-option',
      samplerOptionBtn: '.js-sampler-option-btn',
      samplerOptionAlways: '.js-sampler-option-always',
      flavorJson: '.js-flavor-json',
      samplerJson: '.js-sampler-json',
      flavorItemPreOrderLabel: '.js-flavor-item-pre-order-label',
      preOrderBannerShipsByDate: '.js-pre-order-ships-by-date',
      shippingTextShipsBy: '.js-shipping-text-ships-by',
      shippingText: '.js-shipping-text',
      cartDrawer: 'cart-drawer',
      bundleButton: '.js-scroll-to-bundle',
      bundleSection: '.js-bundle-section',
      flavorClear: '.js-flavor-clear',
      flavorSelector: '.ctr-flavor-selector',
      flavorCategories: '.js-flavor-categories',
      flavorCollapsed: '.js-flavor-collapsed',
      flavorCollapsedCard: '.js-flavor-collapsed-card',
      flavorSelectedLabel: '.js-flavor-selected-label',
      flavorList: '.ctr-flavor-selector__list',
      soldOutMsg: '.ctr-flavor-selector__sold-out-msg',
    };

    this.CLASSES = {
      active: 'm-active',
      selected: 'm-selected',
      loading: 'm-loading',
      hidden: 'm-hidden',
      preorder: 'm-preorder',
      visible: 'is-visible',
    };

    this.loadingText = 'Mixing Your Magna...';

    this.endpoints = {
      cart: '/cart/add.js',
      checkout: '/cart/checkout',
    };

    this.productFlavorsData = [];
    this.currentProductFlavorData = null;
    this.productSelectedFlavorsData = [];
    this.samplerProduct = null;
    this.samplerOptionActive = false;
    this.selectedProductBoxOption = null;
    this.selectedProductFlavors = null;
    this.selectedBox = '1';
    this.buttonLabel = this.cartDrawerButtonText;

    this.isNewSession = false;
    this.subscriptionToCheckout = false;
    this.maxPreOrderInventoryQty = 100000;
    this.freeGiftIds = null;

    this.bundleSlots = [];
    this.bundleMaxQty = 4;
    this.bundleGridActive = false;
  }

  /**
   * Connected callback
   */
  connectedCallback() {
    this.init();
    this.events();
  }

  /**
   * Disconnected callback
   */
  disconnectedCallback() {
    this.destroyEvents();
  }

  /**
   * Attribute changed callback
   */
  attributeChangedCallback(name, oldValue, newValue) {}

  /**
   * Initializes the product box subscription and sets the default values
   */
  init() {
    const $boxOptions = [...this.querySelectorAll(this.SELECTORS.productBoxOption)];
    this.selectedProductBoxOption =
      $boxOptions.find((option) => option.classList.contains(this.CLASSES.active)) || $boxOptions[0];
    if (this.selectedProductBoxOption) {
      this.selectedBox = this.selectedProductBoxOption.getAttribute('data-box');
    }
    this.productFlavorsData = this.parseFlavorJson();

    if (this.preOrderEnabled) {
      this.productFlavorsData = this.productFlavorsData.map((flavor) => {
        return this.updatePreOrderFlavorInfo(flavor);
      });
    }

    this.freeGiftIds = this.parseFreeGiftIds();

    if (this.sharedFlavorSelectorEnabled) {
      this.subscriptionToCheckout = true;
    }

    this.trackSessionAndVisits();
    // this.setPreOrderCookie();
    this.updateSelectedVariants();
    this.selectFlavorFromUrl();
    this.updateFlavorSelectorDescriptions();
    this.updatePurchaseType();
    this.initBundleGrid();
    this.initSoldOutFlavors();

    if (this.defaultSampler) {
      this.handleSamplerOptionClick(null, null);
    } else {
      this.updateNotePrices();
    }
  }

  /**
   * Handles the click event for the product box subscription (using event delegation)
   */
  events() {
    this.addEventListener('click', (event) => {
      const $clearBtn = event.target.closest(this.SELECTORS.flavorClear);
      if ($clearBtn) {
        this.handleFlavorClearClick(event, $clearBtn);
        return;
      }

      const $addToCartBtn = event.target.closest(this.SELECTORS.addToCartBtn);
      const $bundleButton = event.target.closest(this.SELECTORS.bundleButton);
      const $productFlavor = event.target.closest(this.SELECTORS.productFlavor);
      const $productBoxOptions = event.target.closest(this.SELECTORS.productBoxOption);
      const $samplerOptionBtn = event.target.closest(this.SELECTORS.samplerOptionBtn);
      const $samplerOptionAlways = event.target.closest(this.SELECTORS.samplerOptionAlways);

      if ($addToCartBtn) {
        this.handleAddToCartClick(event, $addToCartBtn);
        return;
      }

      if ($bundleButton) {
        this.handleBundleButtonClick(event, $bundleButton);
        return;
      }

      if ($productFlavor) {
        this.handleProductFlavorClick(event, $productFlavor);
        return;
      }

      if ($productBoxOptions) {
        this.handleProductBoxOptionClick(event, $productBoxOptions);
        return;
      }

      if ($samplerOptionBtn || $samplerOptionAlways) {
        this.handleSamplerOptionClick(event, $samplerOptionBtn || $samplerOptionAlways);
        return;
      }
    });
  }

  /**
   * Destroys the events for the product box subscription
   */
  destroyEvents() {
    this.removeEventListener('click', this.handleClick);
  }

  /**
   * Handles the click event for the product flavor
   * @param {Event} event - The click event
   * @param {HTMLElement} $productFlavor - The product flavor element
   */
  handleProductFlavorClick(event = null, $productFlavor) {
    if (event) event.preventDefault();

    const $flavorSelector = $productFlavor.closest(this.SELECTORS.flavorSelector);
    if ($flavorSelector?.getAttribute('data-collapsed') === 'true') {
      return;
    }

    this.querySelectorAll(this.SELECTORS.productFlavor).forEach((flavor) => {
      if (this.sharedFlavorSelectorEnabled) {
        flavor.classList.remove(this.CLASSES.selected);
        flavor.setAttribute('data-variant-selected', 'false');
        return;
      }

      if (
        flavor.getAttribute('data-box') === this.selectedBox &&
        flavor.getAttribute('data-flavor-group') === $productFlavor.getAttribute('data-flavor-group')
      ) {
        flavor.classList.remove(this.CLASSES.selected);
        flavor.setAttribute('data-variant-selected', 'false');
      }
    });
    $productFlavor.classList.add(this.CLASSES.selected);
    $productFlavor.setAttribute('data-variant-selected', 'true');

    this.updateSelectedVariants($productFlavor);
    this.updateFlavorSelectorDescription($productFlavor);
    this.updateSoldOutMessage($productFlavor);

    if (event) {
      this.collapseScrollFlavorSelector($flavorSelector, $productFlavor);
    }

    if (this.preOrderEnabled) {
      this.handleExpectedShipDate(this.currentProductFlavorData);
    }
  }

  /**
   * Clears collapsed scroll selection and restores default first flavor (same as page load)
   */
  handleFlavorClearClick(event, $clearBtn) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const $flavorSelector = $clearBtn.closest(this.SELECTORS.flavorSelector);
    if (!$flavorSelector) return;

    this.expandScrollFlavorSelector($flavorSelector);

    const $firstFlavor = $flavorSelector.querySelector(this.SELECTORS.productFlavor);
    if ($firstFlavor) {
      // Restore default selection without collapsing (same as initial page state)
      this.handleProductFlavorClick(null, $firstFlavor);
      return;
    }

    $flavorSelector.querySelectorAll(this.SELECTORS.productFlavor).forEach((flavor) => {
      flavor.classList.remove(this.CLASSES.selected);
      flavor.setAttribute('data-variant-selected', 'false');
    });
    this.updateSelectedVariants();
    this.updateFlavorSelectorDescriptions();
  }

  /**
   * Collapses a scroll-layout flavor selector to the selected card
   * Keeps the selected category header visible above the collapsed card
   */
  collapseScrollFlavorSelector($flavorSelector, $productFlavor) {
    if (!$flavorSelector || $flavorSelector.getAttribute('data-layout') !== 'scroll') return;

    const $categories = $flavorSelector.querySelector(this.SELECTORS.flavorCategories);
    const $collapsed = $flavorSelector.querySelector(this.SELECTORS.flavorCollapsed);
    const $collapsedCard = $flavorSelector.querySelector(this.SELECTORS.flavorCollapsedCard);
    const $selectedLabel = $flavorSelector.querySelector(this.SELECTORS.flavorSelectedLabel);
    const $selectedCategory = $productFlavor.closest('.ctr-flavor-selector__category');

    if (!$collapsed || !$collapsedCard) return;

    const clone = $productFlavor.cloneNode(true);
    // Display-only clone: must not match .js-flavor-item or it gets counted as a selected flavor in ATC
    clone.classList.remove('js-flavor-item');
    clone.classList.add(this.CLASSES.selected);
    clone.removeAttribute('data-variant-selected');

    const $clear = document.createElement('button');
    $clear.type = 'button';
    $clear.className = 'ctr-flavor-selector__clear js-flavor-clear';
    $clear.setAttribute('aria-label', 'Clear flavor selection');
    $clear.innerHTML = '<span aria-hidden="true">×</span>';

    const $imageWrapper = clone.querySelector('.ctr-flavor-selector__item-image-wrapper');
    if ($imageWrapper) {
      $imageWrapper.appendChild($clear);
    } else {
      clone.appendChild($clear);
    }

    $collapsedCard.innerHTML = '';
    $collapsedCard.appendChild(clone);

    $flavorSelector.querySelectorAll('.ctr-flavor-selector__category').forEach(($category) => {
      const isSelectedCategory = $category === $selectedCategory;
      $category.classList.toggle(this.CLASSES.hidden, !isSelectedCategory);
      $category.querySelectorAll('.ctr-flavor-selector__list').forEach(($list) => {
        $list.classList.add(this.CLASSES.hidden);
      });
    });

    if ($selectedCategory) {
      const $belowDescription = $selectedCategory.querySelector(
        `${this.SELECTORS.flavorSelectorDescription}.ctr-flavor-selector__description--below`,
      );
      if ($belowDescription) {
        $selectedCategory.insertBefore($collapsed, $belowDescription);
      } else {
        $selectedCategory.appendChild($collapsed);
      }
    } else if ($categories) {
      $categories.after($collapsed);
    }

    $collapsed.classList.remove(this.CLASSES.hidden);
    if ($selectedLabel) $selectedLabel.classList.remove(this.CLASSES.hidden);
    $flavorSelector.setAttribute('data-collapsed', 'true');
  }

  /**
   * Expands a scroll-layout flavor selector back to category lists
   */
  expandScrollFlavorSelector($flavorSelector) {
    if (!$flavorSelector || $flavorSelector.getAttribute('data-layout') !== 'scroll') return;

    const $categories = $flavorSelector.querySelector(this.SELECTORS.flavorCategories);
    const $collapsed = $flavorSelector.querySelector(this.SELECTORS.flavorCollapsed);
    const $collapsedCard = $flavorSelector.querySelector(this.SELECTORS.flavorCollapsedCard);
    const $selectedLabel = $flavorSelector.querySelector(this.SELECTORS.flavorSelectedLabel);

    $flavorSelector.querySelectorAll('.ctr-flavor-selector__category').forEach(($category) => {
      $category.classList.remove(this.CLASSES.hidden);
      $category.querySelectorAll('.ctr-flavor-selector__list').forEach(($list) => {
        $list.classList.remove(this.CLASSES.hidden);
      });
    });

    if ($collapsed && $categories) {
      $categories.before($collapsed);
      $collapsed.classList.add(this.CLASSES.hidden);
    }
    if ($collapsedCard) $collapsedCard.innerHTML = '';
    if ($selectedLabel) $selectedLabel.classList.add(this.CLASSES.hidden);
    $flavorSelector.setAttribute('data-collapsed', 'false');
  }

  /**
   * Sync collapsed state for all scroll selectors that already have a selection
   */
  syncScrollCollapsedStates() {
    this.querySelectorAll(`${this.SELECTORS.flavorSelector}[data-layout="scroll"]`).forEach(($selector) => {
      const $selected = $selector.querySelector(`${this.SELECTORS.productFlavor}.${this.CLASSES.selected}`);
      if ($selected) {
        this.collapseScrollFlavorSelector($selector, $selected);
      } else {
        this.expandScrollFlavorSelector($selector);
      }
    });
  }

  /**
   * Handles the click event for the product box option
   * @param {Event} event - The click event
   * @param {HTMLElement} $productBoxOption - The product box option element
   */
  handleProductBoxOptionClick(event, $productBoxOption) {
    if (event) event.preventDefault();
    if (!this.samplerOptionActive && $productBoxOption.getAttribute('data-box') === this.selectedBox) return;

    this.selectedBox = $productBoxOption.getAttribute('data-box');
    this.selectedBoxEl = $productBoxOption;
    this.selectedProductBoxOption = $productBoxOption;
    this.querySelectorAll(this.SELECTORS.productBoxOption).forEach((option) => {
      option.classList.remove(this.CLASSES.active);
    });
    this.toggleSamplerOptionVisibility(false);

    $productBoxOption.classList.add(this.CLASSES.active);
    this.updateSelectedVariants();
    this.updateFlavorSelectorDescriptions();
    this.updateAddToCartButton();
    this.updateNotePrices();
    this.updatePurchaseType();

    if (this.preOrderEnabled) {
      this.handleExpectedShipDate();
    }
  }

  /**
   * Handles the click event for the sampler option
   * @param {Event} event - The click event
   * @param {HTMLElement} $samplerOptionBtn - The sampler option button element
   */
  handleSamplerOptionClick(event, $samplerOptionBtn) {
    if (event) event.preventDefault();

    this.querySelectorAll(this.SELECTORS.productBoxOption).forEach((option) => {
      option.classList.remove(this.CLASSES.active);
    });

    const samplerJson = this.parseSamplerJson();

    if (samplerJson) {
      this.samplerProduct = samplerJson;
    }

    this.toggleSamplerOptionVisibility(true);
    this.updateAddToCartButton();
    this.updateNotePrices();

    window.dispatchEvent(
      new CustomEvent('subscription-option-toggle', {
        detail: '',
      })
    );

    window.dispatchEvent(
      new CustomEvent('sampler-option-toggle', {
        detail: { isOpen: true },
      })
    );

    document.dispatchEvent(
      new CustomEvent('product-box:flavor-changed', {
        detail: { flavorId: this.samplerProduct.variants[0].id },
      })
    );
  }

  /**
   * Handles the click event for the bundle button
   * @param {Event} event - The click event
   * @param {HTMLElement} $bundleButton - The bundle button element
   */
  handleBundleButtonClick(event, $bundleButton) {
    if (event) event.preventDefault();
    this.scrollToBundle();
  }

  handleExpectedShipDate() {
    const $flavors = this.selectedProductBoxOption.querySelectorAll(`${this.SELECTORS.productFlavor}.m-selected`);
    if (!$flavors) return;

    // if only one flavor is selected or all flavors are the same, update the expected ship date
    if ($flavors.length === 1 || this.isSelectedSameFlavors($flavors)) {
      this.updateExpectedShipDate(this.currentProductFlavorData?.preOrderInfo?.preOrder);
      return;
    }
    const preorderFlavors = this.productSelectedFlavorsData.filter((v) => v.preOrderInfo?.preOrder);

    // if there are preorder flavors, update the expected ship date with the biggest expected ship date
    if (preorderFlavors.length > 0) {
      const latestPreorderFlavor = preorderFlavors.reduce((latest, current) => {
        if (!latest.preOrderInfo?.originalExpectedShipDate) return current;
        if (!current.preOrderInfo?.originalExpectedShipDate) return latest;

        return new Date(current.preOrderInfo?.originalExpectedShipDate) >
          new Date(latest.preOrderInfo?.originalExpectedShipDate)
          ? current
          : latest;
      }, preorderFlavors[0]);

      this.updateExpectedShipDate(latestPreorderFlavor?.preOrderInfo?.preOrder, latestPreorderFlavor);
      return;
    }

    // if there are no preorder flavors, update the expected ship date with the current flavor
    this.updateExpectedShipDate(this.currentProductFlavorData.preOrderInfo?.preOrder);
  }

  /**
   * Handles the click event for the add to cart button
   * @param {Event} event - The click event
   * @param {HTMLElement} $addToCartBtn - The add to cart button element
   */
  async handleAddToCartClick(event, $addToCartBtn) {
    if (event) event.preventDefault();

    const oldBtnText = $addToCartBtn.innerText;
    try {
      let redirectTo = this.addToCartType;

      if (this.getSelectedOption().getAttribute('data-can-subscribe') === 'true' && this.subscriptionToCheckout) {
        redirectTo = 'checkout';
      }

      if (this.samplerOptionActive) {
        const type = this.samplerLinkType;
        redirectTo = type.includes('checkout') ? 'checkout' : type.includes('drawer') ? 'drawer' : type;
      }

      $addToCartBtn.classList.add(this.CLASSES.loading);
      $addToCartBtn.setAttribute('disabled', 'true');

      $addToCartBtn.innerText = this.loadingText;
      const $cartDrawer = document.querySelector(this.SELECTORS.cartDrawer);

      if (!$cartDrawer) {
        throw new Error('Cart drawer not found');
      }
      const sections = $cartDrawer.getSectionsToRender().map((section) => section.id);
      let items = this.getItems();

      if (redirectTo === 'checkout') {
        await window.clearCart();
      }

      if (
        this.getSelectedOption().getAttribute('data-can-subscribe') === 'true' &&
        !this.samplerOptionActive &&
        !this.isMonthSupplyDesktopOtp()
      ) {
        items = await this.addFreeGiftsItems(items);
      }

      const response = await fetch(this.endpoints.cart, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          sections: sections,
        }),
      });

      if (!response.ok) {
        throw new Error('There was a problem with the request');
      }

      if (window.location.host.includes('drinkmagna')) {
        window.dataLayer.push({
          event: 'add_to_cart',
          items,
        });
      }

      const json = await response.json();

      if (redirectTo === 'drawer') {
        $cartDrawer.renderContents(json);
      } else {
        document.location.href = this.endpoints.checkout;
      }
    } catch (e) {
      console.error(e.message);
      return null;
    } finally {
      $addToCartBtn.innerText = oldBtnText;
      $addToCartBtn.classList.remove(this.CLASSES.loading);
      $addToCartBtn.removeAttribute('disabled');
    }
  }

  /**
   * Line items from the try-best card, with each box's variant, selling plan, and offer
   * @returns {Array|null}
   */
  getTryBestItems() {
    const option = this.selectedProductBoxOption;
    if (!option) return null;

    const rows = [...option.querySelectorAll('.js-try-best-row')];
    if (!rows.length) return null;

    const items = rows.flatMap((row) => {
      const id = row.getAttribute('data-variant-id');
      if (!id) return [];

      const item = {
        id: Number(id),
        quantity: 1,
      };
      const plan = row.getAttribute('data-selling-plan-id');
      if (plan) item.selling_plan = /^\d+$/.test(plan) ? Number(plan) : plan;

      const offer = row.getAttribute('data-offer');
      if (offer) item.properties = { _offer: offer };

      return [item];
    });

    return items.length ? items : null;
  }

  /**
   * Month-supply desktop OTP mode (769px+ with desktop OTP settings filled).
   * @returns {boolean}
   */
  isMonthSupplyDesktopOtp() {
    const root = this.querySelector('.js-month-supply');
    return !!(
      root &&
      root.getAttribute('data-desktop-otp') === 'true' &&
      window.matchMedia('(min-width: 769px)').matches
    );
  }

  /**
   * Line item from the month-supply inject (3 / 6 / 1 Month): VP variant × qty.
   * Mobile keeps the selling plan; desktop OTP mode omits it (one-time purchase).
   * @returns {Array|null}
   */
  getMonthSupplyItems() {
    const root = this.querySelector('.js-month-supply');
    if (!root) return null;

    const pendingLink = root.querySelector('.js-month-supply-text-link[data-month-supply-pending="true"]');
    const selected =
      pendingLink || root.querySelector('.js-month-supply-option.is-selected');
    if (!selected) return null;

    if (pendingLink) {
      pendingLink.removeAttribute('data-month-supply-pending');
    }

    const id = selected.getAttribute('data-variant-id');
    if (!id) return null;

    const quantity = Number(selected.getAttribute('data-quantity') || 1);
    const item = {
      id: Number(id),
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
    };

    const desktopOtp = this.isMonthSupplyDesktopOtp();
    const plan = selected.getAttribute('data-selling-plan-id');
    if (plan && !desktopOtp) {
      item.selling_plan = /^\d+$/.test(plan) ? Number(plan) : plan;
    }

    const desktopOffer = selected.getAttribute('data-desktop-offer');
    const offer =
      desktopOtp && desktopOffer
        ? desktopOffer
        : selected.getAttribute('data-offer');
    if (offer) {
      item.properties = { _offer: offer };
    } else if (this.offerPropertyValue) {
      item.properties = { _offer: this.offerPropertyValue };
    }

    return [item];
  }

  /**
   * Gets and prepares the items for the cart
   * @returns {Array} An array of items
   */
  getItems() {
    if (this.bundleGridActive && this.selectedBox === '6') {
      return this.getBundleItems();
    }

    const monthSupplyItems = this.getMonthSupplyItems();
    if (monthSupplyItems) {
      return this.appendRoutineAddonItem(monthSupplyItems);
    }

    const tryBestItems = this.getTryBestItems();
    if (tryBestItems) {
      return this.appendRoutineAddonItem(tryBestItems);
    }

    let items = [];

    items = this.productSelectedFlavorsData.map((productFlavorData) => {
      const id = productFlavorData.firstVariantId;
      const quantity = 1;
      const preOrderProperties = productFlavorData.preOrderInfo?.preOrder && productFlavorData.preOrderInfo.expectedShipDate !== '' ? { 'PREORDER': 'SHIPS BY ' + productFlavorData.preOrderInfo.expectedShipDate.toUpperCase() } : {};

      if (this.getSelectedOption().getAttribute('data-can-subscribe') === 'true') {
        const customSellingPlanId = this.getSelectedOption().getAttribute('data-selling-plan-id');
        const sellingPlanId = customSellingPlanId || this.sellingPlanId;

        return {
          id: id,
          quantity: quantity,
          selling_plan: sellingPlanId,
          properties: {
            _offer: this.offerPropertyValue ? this.offerPropertyValue : null,
            ...preOrderProperties
          },
        };
      }

      return {
        id: id,
        quantity: quantity,
        properties: {
          _offer: this.offerPropertyValue ? this.offerPropertyValue : null,
          ...preOrderProperties
        }
      };
    });

    if (this.samplerOptionActive) {
      const samplerItem = {
        id: this.samplerProduct.variants[0].id,
        quantity: 1,
      };

      if (this.getSelectedOption().getAttribute('data-can-subscribe') === 'true') {
        const customSellingPlanId = this.getSelectedOption().getAttribute('data-selling-plan-id');
        samplerItem.selling_plan = customSellingPlanId || this.sellingPlanId;
      }

      if (this.samplerOfferPropertyValue) {
        samplerItem.properties = {
          _offer: this.samplerOfferPropertyValue,
        };
      }

      return [samplerItem];
    }

    return this.appendRoutineAddonItem(items);
  }

  /**
   * Appends the routine addon line item when the toggle is on
   * @param {Array} items - The items array
   * @returns {Array} The items array with the addon item
   */
  appendRoutineAddonItem(items) {
    if (this.samplerOptionActive) return items;

    const option = this.getSelectedOption();
    const addon = option?.querySelector('.ctr-routine-addon.is-on');
    const variantId = addon?.dataset?.variantId;
    if (!addon || !variantId) return items;

    const item = {
      id: Number(variantId),
      quantity: 1,
    };

    if (addon.dataset.sellingPlanId) {
      item.selling_plan = addon.dataset.sellingPlanId;
    }

    if (addon.dataset.offer) {
      item.properties = {
        _offer: addon.dataset.offer,
      };
    }

    items.push(item);
    return items;
  }

  /**
   * Adds the free gifts items to the items array, skipping variants already in cart
   * @param {Array} items - The items array
   * @returns {Promise<Array>} The items array with the free gifts items
   */
  async addFreeGiftsItems(items) {
    if (!this.freeGiftsEnabled || !this.freeGiftIds) {
      return items;
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const existingIds = new Set(cart.items.map((item) => item.id));

    const pushGift = (productId) => {
      if (existingIds.has(Number(productId))) return;
      items.push({
        id: productId,
        quantity: 1,
        properties: {
          _offer: 'FREE GIFT',
        },
      });
    };

    // if there is only one flavor selected and it has metafield starter kit free products, add the free gifts items from the metafield
    if (
      this.productSelectedFlavorsData.length === 1 &&
      this.productSelectedFlavorsData[0].starterKitFreeProducts.length > 0
    ) {
      this.productSelectedFlavorsData[0].starterKitFreeProducts.forEach(pushGift);
      return items;
    }

    // if there are two flavors selected and they are the same and metafield has free gifts, add the free gifts items from the metafield
    if (this.productSelectedFlavorsData.length === 2) {
      if (
        this.productSelectedFlavorsData[0].firstVariantId === this.productSelectedFlavorsData[1].firstVariantId &&
        this.productSelectedFlavorsData[0].starterKitFreeProducts.length > 0
      ) {
        this.productSelectedFlavorsData[0].starterKitFreeProducts.forEach(pushGift);
        return items;
      }
    }

    this.freeGiftIds.forEach(pushGift);

    return items;
  }

  /**
   * Gets the flavor query param from the URL
   * @returns {string} The flavor
   */
  getFlavorFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('flavor')?.toLowerCase();
  }

  /**
   * Gets the selected option
   * @returns {HTMLElement} The selected option
   */
  getSelectedOption() {
    if (this.samplerOptionActive) {
      return this.querySelector(this.SELECTORS.samplerOption);
    }

    return this.selectedProductBoxOption;
  }
  /**
   * Updates the selected variants with shared flavors
   * @param {HTMLElement} $currentProductFlavor - The current product flavor element
   */
  updateSelectedVariantsWithSharedFlavors($currentProductFlavor = null) {
    this.selectedProductFlavors = [...this.querySelectorAll(this.SELECTORS.productFlavor)].filter(
      (flavor) =>
        flavor.getAttribute('data-variant-selected') === 'true' &&
        !flavor.closest(this.SELECTORS.flavorCollapsed)
    );

    this.productSelectedFlavorsData = this.selectedProductFlavors
      .map((flavor) => {
        const variantId = flavor.getAttribute('data-id');
        return this.productFlavorsData.find(
          (flavorData) => Number(flavorData.firstVariantId) === Number(variantId)
        );
      })
      .filter(Boolean);

    if ($currentProductFlavor) {
      const currentId = Number($currentProductFlavor.getAttribute('data-id'));
      this.currentProductFlavorData =
        this.productSelectedFlavorsData.find((flavorData) => Number(flavorData.firstVariantId) === currentId) ||
        this.productFlavorsData.find((flavorData) => Number(flavorData.firstVariantId) === currentId) ||
        null;
    } else {
      this.currentProductFlavorData = this.productSelectedFlavorsData[0] || null;
    }

    if (!this.currentProductFlavorData || !this.selectedProductBoxOption) return;

    document.dispatchEvent(
      new CustomEvent('product-box:flavor-changed', {
        detail: {
          flavorId: this.currentProductFlavorData.firstVariantId,
          quantity: Number(this.selectedProductBoxOption.dataset.quantity),
          canSubscribe: this.selectedProductBoxOption.dataset.canSubscribe === 'true',
        },
      })
    );
  }
  /**
   * Updates the selected variants
   * @param {HTMLElement} $currentProductFlavor - The current product flavor element
   */
  updateSelectedVariants($currentProductFlavor = null) {
    if (this.sharedFlavorSelectorEnabled) {
      this.updateSelectedVariantsWithSharedFlavors($currentProductFlavor);
      return;
    }
    const selectedSwatches = [...this.querySelectorAll(this.SELECTORS.productFlavor)].filter(
      (flavor) =>
        flavor.getAttribute('data-variant-selected') === 'true' &&
        flavor.getAttribute('data-box') === this.selectedBox &&
        !flavor.closest(this.SELECTORS.flavorCollapsed)
    );
    this.selectedProductFlavors = selectedSwatches;
    this.productSelectedFlavorsData = selectedSwatches
      .map((flavor) => {
        const variantId = flavor.getAttribute('data-id');
        return this.productFlavorsData.find(
          (flavorData) => Number(flavorData.firstVariantId) === Number(variantId)
        );
      })
      .filter(Boolean);

    if ($currentProductFlavor) {
      const currentId = Number($currentProductFlavor.getAttribute('data-id'));
      this.currentProductFlavorData =
        this.productSelectedFlavorsData.find((flavorData) => Number(flavorData.firstVariantId) === currentId) ||
        this.productFlavorsData.find((flavorData) => Number(flavorData.firstVariantId) === currentId) ||
        null;
    } else {
      this.currentProductFlavorData = this.productSelectedFlavorsData[0] || null;
    }

    if (this.currentProductFlavorData && this.selectedProductBoxOption) {
      document.dispatchEvent(
        new CustomEvent('product-box:flavor-changed', {
          detail: {
            flavorId: this.currentProductFlavorData.firstVariantId,
            quantity: Number(this.selectedProductBoxOption.dataset.quantity),
            canSubscribe: this.selectedProductBoxOption.dataset.canSubscribe === 'true',
          },
        })
      );
    }
  }

  /**
   * Updates the button label
   * @param {string} label - The label to update the button with
   */
  updateButtonLabel(label) {
    if (!label) return;

    this.querySelector(this.SELECTORS.addToCartBtn).innerText = label;
  }

  /**
   * Updates the pre order flavor info
   * @param {Object} flavorItemData - The flavor item data
   */
  updatePreOrderFlavorInfo(flavorItemData) {
    if (!flavorItemData && !flavorItemData.metafields) {
      return flavorItemData;
    }
    const title = flavorItemData.product.title.toLowerCase().split(' | ')[2];
    const expectedShippingDate = flavorItemData.metafields.expected_shipping_date || null;
    let flavorInventoryQty = flavorItemData.inventoryQuantity || 0;
    let customPreorder = flavorItemData.metafields.preorder || false;

    if (flavorItemData.preOrderException?.toLowerCase().includes(title)) {
      return flavorItemData;
    }

    if (flavorInventoryQty > 0 && !customPreorder) {
      return flavorItemData;
    }

    if (flavorInventoryQty <= 0 && customPreorder) {
      customPreorder = false;
    }

    if (flavorInventoryQty * -1 > this.maxPreOrderInventoryQty) {
      [...this.querySelectorAll(this.SELECTORS.productFlavor)].forEach(($flavor) => {
        if (Number($flavor.getAttribute('data-id')) === Number(flavorItemData.firstVariantId)) {
          $flavor.classList.add(this.CLASSES.hidden);
        }
      });
      return { ...flavorItemData, hideFlavor: true };
    }

    // if the flavor is preorder, update the expected ship date
    const now = new Date().getTime();
    const expectedShipDate = new Date(expectedShippingDate).getTime();
    const isPreOrder = expectedShipDate > now + 2 * 24 * 60 * 60 * 1000;

    const preOrderInfo = {
      preOrder: isPreOrder,
      originalExpectedShipDate: expectedShippingDate,
      expectedShipDate: expectedShippingDate ? this.formatDate(expectedShippingDate) : null,
    };

    [...this.querySelectorAll(this.SELECTORS.productFlavor)].forEach(($flavor) => {
      if (Number($flavor.getAttribute('data-id')) === Number(flavorItemData.firstVariantId)) {
        $flavor
          .querySelector(this.SELECTORS.flavorItemPreOrderLabel)
          .classList.toggle(this.CLASSES.hidden, !preOrderInfo.preOrder);
      }
    });

    return { ...flavorItemData, preOrderInfo: preOrderInfo };
  }

  /**
   * Scrolls to the bundle section with a smooth animation and header offset
   */
  scrollToBundle() {
    const $bundleSection = document.querySelector(this.SELECTORS.bundleSection);
    if (!$bundleSection) return;

    const elementPosition = $bundleSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 72;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }

  /**
   * Updates the add to cart button
   */
  updateAddToCartButton() {
    if (this.bundleGridActive && this.selectedProductBoxOption && Number(this.selectedProductBoxOption.dataset.box) === 6) {
      this.updateBundleUI();
      return;
    }

    if (this.buttonBehavior === 'default') {
      if (
        this.selectedProductBoxOption &&
        Number(this.selectedProductBoxOption.dataset.box) === 6 &&
        !this.samplerOptionActive
      ) {
        this.updateButtonLabel(this.oneTimeButtonText);
      } else {
        this.updateButtonLabel(this.cartDrawerButtonText);
      }
      return;
    }

    const canSubscribe = this.getSelectedOption().getAttribute('data-can-subscribe') === 'true';
    const isNewSession = this.isNewSession;

    if (!canSubscribe) {
      this.buttonLabel = this.cartDrawerButtonText;
    } else if (isNewSession) {
      this.buttonLabel = this.checkoutButtonText;
      this.subscriptionToCheckout = true;
    } else {
      this.buttonLabel = this.cartDrawerButtonText;
      this.subscriptionToCheckout = false;
    }

    this.updateButtonLabel(this.buttonLabel);
  }

  /**
   * Toggles the sampler option visibility / active state
   * @param {boolean} visible - Whether the sampler option should be active
   */
  toggleSamplerOptionVisibility(visible) {
    const $samplerOption = this.querySelector(this.SELECTORS.samplerOption);
    if (!$samplerOption) {
      return;
    }

    this.samplerOptionActive = visible;

    if ($samplerOption.matches(this.SELECTORS.samplerOptionAlways)) {
      $samplerOption.classList.toggle(this.CLASSES.active, visible);
      return;
    }

    $samplerOption.classList.toggle(this.CLASSES.hidden, !visible);
    const $samplerOptionBtn = this.querySelector(this.SELECTORS.samplerOptionBtn);
    if ($samplerOptionBtn) {
      $samplerOptionBtn.classList.toggle(this.CLASSES.hidden, visible);
    }
  }

  /**
   * Updates the expected ship date
   * @param {boolean} hideExpectedShipDate - Whether to hide the expected ship date
   * @param {Object} flavorData - The target flavor data
   */
  updateExpectedShipDate(hideExpectedShipDate = false, flavorData = this.currentProductFlavorData) {
    this.querySelector(this.SELECTORS.shippingText).classList.toggle(this.CLASSES.hidden, hideExpectedShipDate);
    this.querySelector(this.SELECTORS.shippingTextShipsBy).classList.toggle(this.CLASSES.hidden, !hideExpectedShipDate);

    if (hideExpectedShipDate) {
      this.querySelectorAll(this.SELECTORS.preOrderBannerShipsByDate).forEach(($shipsByDate) => {
        $shipsByDate.innerText = flavorData?.preOrderInfo?.expectedShipDate;
      });
    }
  }

  /**
   * Updates the purchase type
   */
  updatePurchaseType() {
    this.setAttribute('purchase-type', this.selectedProductBoxOption.getAttribute('data-can-subscribe') === 'true' ? 'subscription' : 'one-time');
  }

  /**
   * Selects the flavor from the URL
   */
  /**
   * Selects the flavor from the URL across every box option / flavor group
   * (1-box, 2-box groups, OTP), not only the currently active box.
   */
  selectFlavorFromUrl() {
    const urlFlavor = this.getFlavorFromUrl();
    const flavorParam = urlFlavor
      ? urlFlavor
      : this.currentProductFlavorData?.product?.title?.toLowerCase();

    if (!flavorParam) return;

    const flavorData = this.productFlavorsData.find((flavorData) =>
      flavorData.product.title.toLowerCase().includes(flavorParam)
    );
    if (!flavorData) return;

    const variantId = Number(flavorData.firstVariantId);
    const $matchingItems = [...this.querySelectorAll(this.SELECTORS.productFlavor)].filter(
      (item) => Number(item.getAttribute('data-id')) === variantId
    );
    if (!$matchingItems.length) return;

    if (this.sharedFlavorSelectorEnabled) {
      this.handleProductFlavorClick(null, $matchingItems[0]);
      return;
    }

    const previousBox = this.selectedBox;
    const previousOption = this.selectedProductBoxOption;
    const appliedKeys = new Set();

    $matchingItems.forEach(($flavorItem) => {
      const box = $flavorItem.getAttribute('data-box');
      const group = $flavorItem.getAttribute('data-flavor-group') || '1';
      const key = `${box}::${group}`;
      if (appliedKeys.has(key)) return;
      appliedKeys.add(key);

      this.selectedBox = box;
      const option = this.querySelector(`${this.SELECTORS.productBoxOption}[data-box="${box}"]`);
      if (option) this.selectedProductBoxOption = option;

      this.handleProductFlavorClick(null, $flavorItem);
    });

    this.selectedBox = previousBox;
    this.selectedProductBoxOption = previousOption;
    this.updateSelectedVariants();
  }

  isSelectedSameFlavors($flavors) {
    const flavorIds = Array.from($flavors).map((flavor) => flavor.getAttribute('data-id'));
    const duplicates = flavorIds.filter((id, index) => flavorIds.indexOf(id) !== index);

    return duplicates.length > 0;
  }

  /**
   * Tracks the session and visits
   */
  trackSessionAndVisits() {
    let totalVisits = parseInt(localStorage.getItem('magnaVisitCount')) || 0;
    const isNewSession = !sessionStorage.getItem('magnaSessionStarted');

    localStorage.setItem('magnaVisitCount', ++totalVisits);

    if (isNewSession) {
      sessionStorage.setItem('magnaSessionStarted', 'true');
      this.isNewSession = true;
    }
  }

  /**
   * Parses the flavor JSON and returns an array of flavor objects
   * @returns {Array} An array of flavor objects
   */
  parseFlavorJson() {
    let flavorJsons = [];
    try {
      flavorJsons = [...this.querySelectorAll(this.SELECTORS.flavorJson)].map((flavor) => {
        return JSON.parse(flavor.innerHTML);
      });
    } catch (e) {
      console.error(e.message);
      return [];
    }
    return flavorJsons;
  }

  /**
   * Parses the sampler JSON and returns sampler product object
   * @returns {Object} A sampler product object
   */
  parseSamplerJson() {
    try {
      return JSON.parse(this.querySelector(this.SELECTORS.samplerJson).innerText);
    } catch (e) {
      console.error(e.message);
      return null;
    }
  }

  /**
   * Parses the free gift IDs
   * @returns {Array} An array of free gift IDs
   */
  parseFreeGiftIds() {
    try {
      if (!this.freeGiftsProductsIds) return null;

      return this.freeGiftsProductsIds
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id !== '')
        .map((id) => Number(id));
    } catch (e) {
      console.error(e.message);
      return null;
    }
  }

  updateFlavorSelectorDescription($productFlavor) {
    if (!this.flavorSelectorDescriptionEnabled || !$productFlavor) return;

    const $flavorSelector = $productFlavor.closest('.ctr-flavor-selector');
    if (!$flavorSelector) return;

    $flavorSelector.querySelectorAll(this.SELECTORS.flavorSelectorDescription).forEach(($el) => {
      $el.textContent = '';
    });

    const $category = $productFlavor.closest('.ctr-flavor-selector__category');
    const $description =
      $category?.querySelector(this.SELECTORS.flavorSelectorDescription) ||
      $flavorSelector.querySelector(this.SELECTORS.flavorSelectorDescription);
    if (!$description) return;

    const description = $productFlavor.dataset.flavorDescription || '';
    const displayName = $productFlavor.dataset.flavorDisplayName || '';
    $description.textContent = description ? `${displayName}: ${description}` : '';
  }

  updateFlavorSelectorDescriptions() {
    if (!this.flavorSelectorDescriptionEnabled) return;

    this.querySelectorAll(`${this.SELECTORS.productFlavor}.m-selected`).forEach(($productFlavor) => {
      this.updateFlavorSelectorDescription($productFlavor);
    });
  }

  /**
 * Updates the note prices based on the selected box
 */
updateNotePrices() {
  const $notePrices = document.querySelector('.js-note-prices');
  if (!$notePrices) return;

  const $oldPrice = $notePrices.querySelector('.js-note-price-old');
  const $newPrice = $notePrices.querySelector('.js-note-price-new');

  const selectedBox = this.selectedProductBoxOption?.getAttribute('data-box');

  let oldPriceValue = '';
  let newPriceValue = '';

  if (this.samplerOptionActive) {
    oldPriceValue = $notePrices.dataset.samplerOldPrice;
    newPriceValue = $notePrices.dataset.samplerNewPrice;
  } else if (selectedBox === '1') {
    oldPriceValue = $notePrices.dataset.oneBoxOldPrice;
    newPriceValue = $notePrices.dataset.oneBoxNewPrice;
  } else if (selectedBox === '2') {
    oldPriceValue = $notePrices.dataset.twoBoxOldPrice;
    newPriceValue = $notePrices.dataset.twoBoxNewPrice;
  } else if (selectedBox === '3') {
    oldPriceValue = $notePrices.dataset.threeBoxOldPrice;
    newPriceValue = $notePrices.dataset.threeBoxNewPrice;
  } else if (selectedBox === '6') {
    oldPriceValue = $notePrices.dataset.oneTimeOldPrice;
    newPriceValue = $notePrices.dataset.oneTimeNewPrice;
  }

  if (oldPriceValue && oldPriceValue !== '' && oldPriceValue !== 'undefined' && oldPriceValue !== '0') {
    $oldPrice.innerText = `$${oldPriceValue}`;
    $oldPrice.style.display = '';
  } else {
    $oldPrice.style.display = 'none';
  }

  $newPrice.innerText = `$${newPriceValue}`;
}

  /**
   * Sets the pre order cookie
   */
  setPreOrderCookie() {
    const preOrderShowing = getCookie('preorder_showing');
    if (!preOrderShowing) {
      setCookie('preorder_showing', new Date().toUTCString());
      return;
    }
    const cookieIsOlderThan24Hours = new Date().getTime() - new Date(preOrderShowing).getTime() > 24 * 60 * 60 * 1000;

    if (cookieIsOlderThan24Hours) {
      this.updateButtonLabel(this.cartDrawerButtonText);
    }
  }

  /**
   * Formats the date
   * @param {string} date - The date to format
   * @returns {string} The formatted date
   */
  formatDate(date) {
    if (!date) return null;
    // Create date object and force it to use local timezone
    const [year, month, day] = date.split('-').map(Number);
    const localDate = new Date(year, month - 1, day);

    const dayNum = localDate.getDate();
    const suffix = dayNum >= 10 && dayNum <= 20 ? 'th' : ['st', 'nd', 'rd'][(dayNum % 10) - 1] || 'th';

    return (
      localDate.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
      }) + suffix
    );
  }

  get addToCartType() {
    return this.getAttribute('add-to-cart-type') || 'drawer';
  }

  get offerPropertyValue() {
    return this.getAttribute('offer-property-value');
  }

  get samplerOfferPropertyValue() {
    return this.getAttribute('sampler-offer-property-value');
  }

  get sellingPlanId() {
    return this.getAttribute('selling-plan-id');
  }

  get preOrderEnabled() {
    return this.getAttribute('pre-order-enabled') === 'true';
  }

  get cartDrawerButtonText() {
    return this.getAttribute('cart-drawer-button-text');
  }

  get checkoutButtonText() {
    return this.getAttribute('checkout-button-text');
  }

  get preOrderButtonText() {
    return this.getAttribute('pre-order-button-text');
  }

  get samplerLinkType() {
    return this.getAttribute('sampler-link-type');
  }

  get defaultSampler() {
    return this.getAttribute('default-sampler') === 'true';
  }

  get starterKitEnabled() {
    return this.getAttribute('starter-kit-enabled') === 'true';
  }

  get freeGiftsEnabled() {
    return this.getAttribute('free-gifts-enabled') === 'true';
  }

  get freeGiftsProductsIds() {
    return this.getAttribute('free-gifts-products-ids') || null;
  }

  get buttonBehavior() {
    return this.getAttribute('button-behavior') || 'default';
  }

  get oneTimeButtonText() {
    return this.getAttribute('one-time-button-text') || this.cartDrawerButtonText;
  }

  get sharedFlavorSelectorEnabled() {
    return this.getAttribute('shared-flavor-selector-enabled') === 'true';
  }

  get flavorSelectorDescriptionEnabled() {
    return this.getAttribute('flavor-selector-description-enabled') === 'true';
  }

  // --- Bundle Grid ---

  initBundleGrid() {
    const $grid = this.querySelector('.js-bundle-grid');
    if (!$grid) return;

    this.bundleGridActive = true;

    $grid.addEventListener('click', (event) => {
      const $minusBtn = event.target.closest('.js-bundle-flavor-minus');
      const $slotRemove = event.target.closest('.js-bundle-slot-remove');
      const $flavor = event.target.closest('.js-bundle-flavor');

      if ($minusBtn) {
        event.stopPropagation();
        const $f = $minusBtn.closest('.js-bundle-flavor');
        this.handleBundleMinus($f);
        return;
      }
      if ($slotRemove) {
        const $slot = $slotRemove.closest('.js-bundle-slot');
        const productId = $slot.dataset.productId;
        if (productId) this.handleBundleRemoveByProductId(productId);
        return;
      }
      if ($flavor) {
        this.handleBundleAdd($flavor);
        return;
      }
    });
  }

  getBundleTotalQty() {
    return this.bundleSlots.reduce((sum, s) => sum + s.quantity, 0);
  }

  handleBundleAdd($flavor) {
    const variantId = $flavor.dataset.variantId;
    const productId = $flavor.dataset.productId;
    const image = $flavor.dataset.image;
    const title = $flavor.dataset.title;

    const total = this.getBundleTotalQty();
    if (total >= this.bundleMaxQty) return;

    const existing = this.bundleSlots.find((s) => s.productId === productId);
    if (existing) {
      existing.quantity++;
    } else {
      this.bundleSlots.push({ productId, variantId, image, title, quantity: 1 });
    }

    this.updateBundleUI();
  }

  handleBundleMinus($flavor) {
    const productId = $flavor.dataset.productId;
    const existing = this.bundleSlots.find((s) => s.productId === productId);
    if (!existing) return;

    existing.quantity--;
    if (existing.quantity <= 0) {
      this.bundleSlots = this.bundleSlots.filter((s) => s.productId !== productId);
    }

    this.updateBundleUI();
  }

  handleBundleRemoveByProductId(productId) {
    const existing = this.bundleSlots.find((s) => s.productId === productId);
    if (!existing) return;

    existing.quantity--;
    if (existing.quantity <= 0) {
      this.bundleSlots = this.bundleSlots.filter((s) => s.productId !== productId);
    }

    this.updateBundleUI();
  }

  updateBundleUI() {
    const $grid = this.querySelector('.js-bundle-grid');
    if (!$grid) return;

    const total = this.getBundleTotalQty();
    const isMaxReached = total >= this.bundleMaxQty;

    // Update flavor add/qty controls
    $grid.querySelectorAll('.js-bundle-flavor').forEach(($flavor) => {
      const productId = $flavor.dataset.productId;
      const slot = this.bundleSlots.find((s) => s.productId === productId);
      const qty = slot ? slot.quantity : 0;

      const $addBtn = $flavor.querySelector('.js-bundle-flavor-add');
      const $qtyBlock = $flavor.querySelector('.js-bundle-flavor-qty');
      const $qtyValue = $flavor.querySelector('.js-bundle-flavor-qty-value');

      if (qty > 0) {
        $addBtn.style.display = 'none';
        $qtyBlock.style.display = '';
        $qtyValue.textContent = qty;
      } else {
        $addBtn.style.display = '';
        $qtyBlock.style.display = 'none';
      }

      if (isMaxReached && qty === 0) {
        $addBtn.classList.add('disabled');
      } else {
        $addBtn.classList.remove('disabled');
      }
    });

    // Update slot visuals
    const $slots = $grid.querySelectorAll('.js-bundle-slot');
    const expandedSlots = [];
    this.bundleSlots.forEach((s) => {
      for (let i = 0; i < s.quantity; i++) {
        expandedSlots.push(s);
      }
    });

    $slots.forEach(($slot, index) => {
      const $icon = $slot.querySelector('.js-bundle-slot-icon');
      const $imageWrap = $slot.querySelector('.js-bundle-slot-image');
      const $img = $slot.querySelector('.js-bundle-slot-img');
      const slotData = expandedSlots[index];

      if (slotData) {
        const isNew = $icon.style.display !== 'none' || $img.src !== slotData.image;
        $icon.style.display = 'none';
        $imageWrap.style.display = '';
        $img.src = slotData.image;
        $img.alt = slotData.title;
        $slot.dataset.productId = slotData.productId;
        if (isNew) {
          $imageWrap.style.animation = 'none';
          $imageWrap.offsetHeight;
          $imageWrap.style.animation = '';
        }
      } else {
        $icon.style.display = '';
        $imageWrap.style.display = 'none';
        $img.src = '';
        delete $slot.dataset.productId;
      }
    });

    // Update add to cart button state
    const $btn = this.querySelector('.js-add-to-cart-btn');
    if ($btn) {
      if (total === 0) {
        $btn.setAttribute('disabled', 'true');
        $btn.classList.add('m-disabled');
        $btn.innerText = 'Select a Flavor';
      } else {
        $btn.removeAttribute('disabled');
        $btn.classList.remove('m-disabled');
        $btn.innerText = this.oneTimeButtonText || 'Buy It Once';
      }
    }
  }

  getBundleItems() {
    const items = [];
    this.bundleSlots.forEach((slot) => {
      items.push({
        id: Number(slot.variantId),
        quantity: slot.quantity,
      });
    });
    return this.appendRoutineAddonItem(items);
  }

  // --- Sold Out Flavor Handling ---

  initSoldOutFlavors() {
    this.querySelectorAll(`${this.SELECTORS.productFlavor}[data-preorder="true"]`).forEach((item) => {
      if (this.isSoldOutPreorderActive(item)) return;
      item.classList.remove(this.CLASSES.preorder);
      item.removeAttribute('data-preorder');
    });

    const soldOutItems = [...this.querySelectorAll(`${this.SELECTORS.productFlavor}[data-preorder="true"]`)];
    if (!soldOutItems.length) return;

    soldOutItems.forEach((item) => {
      item.classList.add(this.CLASSES.preorder);
      this.ensureSoldOutMessage(item);
    });

    this.querySelectorAll(`${this.SELECTORS.productFlavor}.${this.CLASSES.selected}[data-preorder="true"]`).forEach(
      (item) => {
        this.updateSoldOutMessage(item);
      }
    );
  }

  isSoldOutPreorderActive(item) {
    if (item.getAttribute('data-preorder') !== 'true') return false;

    const flavorData = this.productFlavorsData.find(
      (flavor) => Number(flavor.firstVariantId) === Number(item.getAttribute('data-id'))
    );
    const expectedShippingDate = flavorData?.metafields?.expected_shipping_date;
    if (!expectedShippingDate) return true;

    const expectedShipDate = new Date(expectedShippingDate).getTime();
    if (Number.isNaN(expectedShipDate)) return true;

    return expectedShipDate > Date.now() + 2 * 24 * 60 * 60 * 1000;
  }

  ensureSoldOutMessage(item) {
    const flavorList = item.closest(this.SELECTORS.flavorList);
    if (!flavorList) return;

    let msg = this.getSoldOutMessage(flavorList);
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'ctr-flavor-selector__sold-out-msg';
    }

    if (flavorList.nextElementSibling !== msg) {
      flavorList.insertAdjacentElement('afterend', msg);
    }
  }

  getSoldOutMessage(flavorList) {
    let node = flavorList?.nextElementSibling;
    while (node) {
      if (node.classList.contains('ctr-flavor-selector__sold-out-msg')) return node;
      if (node.classList.contains('ctr-flavor-selector__list')) break;
      node = node.nextElementSibling;
    }
    return null;
  }

  updateSoldOutMessage($productFlavor) {
    const $flavorSelector = $productFlavor.closest(this.SELECTORS.flavorSelector);
    if (!$flavorSelector) return;

    $flavorSelector.querySelectorAll(this.SELECTORS.soldOutMsg).forEach((msg) => {
      msg.classList.remove(this.CLASSES.visible);
    });

    if (!this.isSoldOutPreorderActive($productFlavor)) return;

    const flavorList = $productFlavor.closest(this.SELECTORS.flavorList);
    const msg = this.getSoldOutMessage(flavorList);
    if (!msg) return;

    msg.textContent = this.formatSoldOutShipDate($productFlavor.getAttribute('data-ship-date'));
    msg.classList.add(this.CLASSES.visible);
  }

  getOrdinal(day) {
    const n = parseInt(day);
    if (n > 3 && n < 21) return n + 'th';
    switch (n % 10) {
      case 1: return n + 'st';
      case 2: return n + 'nd';
      case 3: return n + 'rd';
      default: return n + 'th';
    }
  }

  formatSoldOutShipDate(raw) {
    if (!raw) return 'PREORDER';
    const parts = raw.trim().split(' ');
    const day = parts[parts.length - 1];
    parts[parts.length - 1] = this.getOrdinal(day);
    return ('PREORDER. ' + parts.join(' ') + '.').toUpperCase();
  }
}
if (!customElements.get('product-box-subscription-creatine')) {
  customElements.define('product-box-subscription-creatine', ProductBoxSubscriptionCreatine);
}
